export default "__VITE_ASSET__DBFVnDQE__"